import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	statusCardActive: {
		borderColor: theme.palette.success.light,
		backgroundColor:
			theme.palette.mode === 'dark' ? 'rgba(76, 175, 80, 0.14)' : 'rgba(76, 175, 80, 0.08)'
	},
	statusCardInactive: {
		borderColor: theme.palette.error.light,
		backgroundColor:
			theme.palette.mode === 'dark' ? 'rgba(244, 67, 54, 0.14)' : 'rgba(244, 67, 54, 0.08)'
	}
}));
